import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const RoxburghParkEmergencyDentistPage = () => (
  <ServiceLocationTemplate suburbName="Roxburgh Park" suburbSlug="roxburgh-park" variant="emergency-dentist" />
);

export default RoxburghParkEmergencyDentistPage;
